// bao migrate skip
import TabPage from "./../../../factories/tab-page";
import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
import "./../../../services/bao-menu";
import GenericListSearchTab from "./../../../factories/generic-list-search-tab";
import * as ko from "knockout";
import BaoDialog from "./../../../factories/bao-dialog";
import Bao from "./../../../services/bao-service";
class ColumnProfileFieldsTab extends GenericListSearchTab {
    FieldName: KnockoutObservable<string> = ko.observable("");
    PageSize = ko.observable(20);
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;

        this.PageSize.subscribe(() => {
            this.Get();
        });
    }
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() { return "checkware-field"; }
    CustomFilter() {
        return null;
    }
    CustomToolbarClick = (action) => {
        if (this.TabPage.IsActiveTab()) {
            switch (action.ActionKey()) {
                case "ColumnProfileFieldsTabUp":
                    //sortIndex - 1 und sortIndex vorheriges Element + 1 (sortIndex um 1 verringern, damit das model in der liste eine Position nach oben rutscht)
                    this.ChangeSortIndexModels(false, this.Selection()[0]);
                    break;
                case "ColumnProfileFieldsTabDown":
                    // sortIndex + 1 und sortIndex vorheriges Element -1 (sortIndex um 1 erhöhen, damit das model in der liste eine Position nach unten rutscht)
                    this.ChangeSortIndexModels(true, this.Selection()[0]);
                    break;
            }
        }
    };
    ChangeSortIndexModels(indexUp, model) {
        return Bao.post("ColumnProfileFieldsTab/ChangeSortIndex", JSON.stringify({
            model: model,
            sortIndexUp: indexUp,
            sessionTabId: this.SessionTabId,
            sorting: this.Sorting(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result) => {
            if (result.ChangeResult == true) {
                this.Get();
            }
            else {
                //Message
            }
        });
    }
    ;
    Bao = Bao;
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        def.resolve(true);
        return def.promise();
    }
    SaveSearchItem(searchItem) {
        searchItem.PrimaryKeyValue = searchItem.FieldId;
        return super.SaveSearchItem(searchItem);
    }
    ;
}
export default ColumnProfileFieldsTab;